import { useState } from 'react';
import { SketchPicker } from 'react-color';
export const ColorPicker = ({setChoices,choices,choice,idx}) => {
  const [openPicker, setOpenPicker] = useState(null);
  return <>
    <div className="swatch" onClick={() => setOpenPicker(openPicker === idx ? null : idx)}>
      <div className="color-box" style={{ background: choice.color }} />
    </div>
    {openPicker === idx && (
      <div className="popover">
        <div className="cover" onClick={() => {
            setOpenPicker(null)
            }}/>
        <SketchPicker
          color={choice.color}
          onChange={(updatedColor) => {
            const newChoices = [...choices];
            newChoices[idx].color = updatedColor.hex;
            setChoices(newChoices);
          }}
        />
      </div>
    )}
  </>
}
